import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'nubes_cookies_ok_v1';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[55] px-4 pb-4"
      style={{ pointerEvents: 'none' }}
    >
      <div
        className="max-w-2xl mx-auto rounded-2xl border border-white/10 bg-black/90 backdrop-blur-xl shadow-[0_-4px_40px_rgba(0,0,0,0.6)] px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4"
        style={{ pointerEvents: 'auto' }}
      >
        <Cookie className="w-5 h-5 text-orange-400 shrink-0 mt-0.5 sm:mt-0" />
        <p className="text-sm text-white/70 leading-snug flex-1">
          Usamos cookies para mejorar tu experiencia. Al continuar navegando aceptas nuestra{' '}
          <Link
            to="/aviso-de-privacidad"
            className="text-orange-400 hover:underline font-semibold"
            data-testid="cookie-banner-privacy-link"
          >
            Política de Privacidad
          </Link>.
        </p>
        <button
          onClick={accept}
          data-testid="cookie-banner-accept-btn"
          className="shrink-0 px-5 py-2 rounded-full bg-orange-500 hover:bg-orange-400 text-black font-bold text-sm transition-colors"
        >
          Aceptar
        </button>
      </div>
    </div>
  );
}
